import { render, staticRenderFns } from "./CrearAuxiliar.vue?vue&type=template&id=4a58bd20"
import script from "./CrearAuxiliar.vue?vue&type=script&lang=js"
export * from "./CrearAuxiliar.vue?vue&type=script&lang=js"
import style0 from "./CrearAuxiliar.vue?vue&type=style&index=0&id=4a58bd20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports